import { callAPI } from "../services/api";

export const getVehicleAndCustomerInfo = async (searchedValue, storeId) => {
  const { customerInfo } = searchedValue;
  let response = await callAPI(`vehicles/customers${customerInfo}`);
  if (response && response.isInvalid) {
    return response;
  }
  return mapResponse(response);
};

const unknownString = 'Unknown'

const mapResponse = (response) => {
  return response.map(data => {
    return {
      'customerName': data.customerVehicle.customer.customerName,
      'yearMakeModel': mapYearMakeModel(data.customerVehicle.vehicle.year, data.customerVehicle.vehicle.make, data.customerVehicle.vehicle.model),
      'licensePlate': data.customerVehicle.vehicle.licensePlate ? data.customerVehicle.vehicle.licensePlate : unknownString,
      'state': data.customerVehicle.vehicle.state ? data.customerVehicle.vehicle.state : unknownString,
      'phone': data.customerVehicle.customer.phone ? data.customerVehicle.customer.phone : unknownString,
      'email': data.customerVehicle.customer.email ? data.customerVehicle.customer.email : data.customerVehicle.customer.alternateEmail ? data.customerVehicle.customer.alternateEmail : unknownString,
      'workOrderId': data.customerVehicle.workOrderId ? data.customerVehicle.workOrderId : '',
      'storeId': data.customerVehicle.storeId ? data.customerVehicle.storeId : '',
      'vehicleId': data.customerVehicle.vehicle.vehicleId ? data.customerVehicle.vehicle.vehicleId : ''
    }
  })
}

const mapYearMakeModel = (year, make, model) => {
  const yearMakeModel = `${year ? year + ' ' : ''}${make ? make + ' ' : ''}${model ? model : ''}`
  return yearMakeModel ? yearMakeModel : unknownString
}